import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Divider,
  Typography,
} from "@suraasa/placebo-ui"
import { Assignment } from "api/resources/assignments/types"
import { getParentItem } from "features/LearningItems/getProductDisplayConfig"
import React, { ReactNode } from "react"
import { useEnrollments } from "utils/hooks/useEnrollments"

import { frontendFAQs } from "./utils"

function FaqCard({
  question,
  answer,
  showBottomLine = true,
  onToggle,
  questionIndex,
}: {
  question: string
  answer: ReactNode
  showBottomLine?: boolean
  expanded: boolean
  onToggle: () => void
  questionIndex: number
}) {
  return (
    <>
      <Accordion onChange={onToggle} type="single">
        <AccordionItem value={`question-${questionIndex}`}>
          <AccordionTrigger className="py-2">
            <Typography variant="strong">{question}</Typography>
          </AccordionTrigger>

          <AccordionContent>
            {typeof answer === "string" ? (
              <Typography className="pb-1 text-onSurface-500">
                {answer}
              </Typography>
            ) : (
              <div className="py-1">{answer}</div>
            )}
          </AccordionContent>
        </AccordionItem>
      </Accordion>
      {showBottomLine && <Divider weight="light" />}
    </>
  )
}

const FaqsContent = ({
  data,
  courseId,
}: {
  courseId: number
  data: Assignment
}) => {
  const [expanded, setExpanded] = React.useState<string>("")

  const toggle = (panel: string) => {
    if (expanded === panel) setExpanded("")
    else setExpanded(panel)
  }

  const { enrollments } = useEnrollments()

  const isThroughPgCTL =
    getParentItem(enrollments, courseId, "id")?.isPgCTL === true
  const isThroughMed =
    getParentItem(enrollments, courseId, "id")?.isMED === true

  const faqs = [
    ...frontendFAQs(data, {
      isThroughPgCTL,
      isThroughMed,
    }),
    ...(data.faqs || []),
  ]

  return (
    <div>
      {faqs.map((faq, i) => (
        <FaqCard
          answer={faq.answer}
          expanded={expanded === `faq${i}`}
          key={i}
          question={faq.question}
          questionIndex={i}
          onToggle={() => toggle(`faq${i}`)}
          showBottomLine={i === faqs.length - 1 ? false : true}
        />
      ))}
    </div>
  )
}

export default FaqsContent
